<template>
  <div class="lesson-info">
    <div class="lesson-price">
      <div class="cash-point" v-if="priceType === 'CASH_POINT'">
        <div class="point-price">
          <div class="price-tag">积分价</div>
          <div class="real-price"><span v-if="spvPoint.item.price.pointPrice > 0 "><price :data="spvPoint.item.price.pointPrice"/> + </span>{{spvPoint.item.price.point}} <span class="unit">积分{{spvPoint.single ? '' : '起' }}</span></div>
          <div class="raw-price"><price :data="spvPoint.item.price.rawPrice"/>{{ spvPoint.single ? '' : '起' }}</div>
        </div>
        <div class="cash-price" v-if="product.allowOnlyCash">
          <div class="price-tag">现金价</div>
          <div class="real-price"><price :data="spvCash.item.price.price"/><span class="unit">{{ spvCash.single ? '' : '起' }}</span></div>
          <div class="raw-price" v-if="spvCash.item.price.rawPrice != spvCash.item.price.price"><price :data="spvCash.item.price.rawPrice" />{{ spvCash.single ? '' : '起'}}</div>
        </div>
      </div>
      <div class="cash-only" v-else-if="priceType === 'CASH_ONLY' && product.allowOnlyCash">
        <div class="cash-price">
          <div class="real-price"><price :data="spvCash.item.price.price"/><span class="unit"> {{ spvCash.single ? '' : '起' }}</span></div>
          <div class="raw-price" v-if="spvCash.item.price.rawPrice != spvCash.item.price.price"><price :data="spvCash.item.price.rawPrice" />{{ spvCash.single ? '' : '起' }}</div>
        </div>
      </div>
      <div class="free" v-else-if="priceType === 'FREE'">免费报名</div>
    </div>

    <div class="lesson-class">
      <div class="tit">场次信息</div>
      <div class="class-item"><span>时间: </span>{{ classTime }}</div>
      <div class="class-item"><span>地点: </span>{{ classCity }}</div>
      <!-- <div class="class-item"><span>说明: </span>{{ product.tips }}</div> -->
      <div class="class-item" v-if="product.status === 'REGISTER'"><span>报名截止时间: </span>{{ product.registerEndTime }}</div>
    </div>
  </div>
</template>

<script>
import Price from '@/price/index'

const EMUM_PRICE_TYPE = ['FREE', 'CASH_ONLY', 'CASH_POINT']

export default {
  components: {
    Price
  },

  props: {
    product: Object
  },

  data () {
    return {
      priceType: EMUM_PRICE_TYPE[0],
      spvPoint: null,
      spvCash: null,
      classTime: '',
      classCity: ''
    }
  },
  
  created() {
    this.classTime = this.product.date.join('/')
    this.classCity = this.product.cityNames.join('/')

    this.getPrice(this.product.times)
  },

  methods: {
    getPrice (times) {
      const arrPointPrice = []
      const arrCashPrice = []

      times.forEach((spv, index) => {
        const {
          point,
          price
        } = spv.price

        if (point > 0) {
          arrPointPrice.push(spv)
        }

        if (price >= 0) {
          arrCashPrice.push(spv)
        }
      })

      if (arrPointPrice.length) {
        this.spvPoint = this.pointPrice(arrPointPrice)
        this.spvCash = this.cashPrice(arrCashPrice)

        this.priceType = EMUM_PRICE_TYPE[2] // POINT_CASH
      }
      else {
        this.spvCash = this.cashPrice(arrCashPrice)

        if (this.spvCash.free) {
          this.priceType = EMUM_PRICE_TYPE[0] // FREE
        }
        else {
          this.priceType = EMUM_PRICE_TYPE[1] // CASH_ONLY
        }
      }
    },

    pointPrice (arrPointPrice) {
      const price = arrPointPrice.sort(this.pointSort)
      let single = false

  
      if (price[0].price.pointPrice === price[price.length - 1].price.pointPrice) {
        single = true
      }

      return {
        item: price[0],
        single
      }
    },

    cashPrice (arrCashPrice) {
      const price = arrCashPrice.sort(this.cashSort)

      let single = false
      let free = false

      if (price[0].price.price === price[price.length - 1].price.price) {
        single = true

        if (price[0].price.price === 0) {
          free = true
        }
      }

      return {
        item: price[0],
        single,
        free
      }
    },

    pointSort (prev, next) {
      const point = prev.price.point - next.price.point
      const pointPrice = prev.price.pointPrice - next.price.pointPrice

      return point === 0 ? pointPrice : point
    },

    cashSort (prev, next) {
      return prev.price.price - next.price.price
    }
  }
}
</script>

<style lang="stylus">

</style>



// WEBPACK FOOTER //
// product-info.vue?7e125122